import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { first } from 'rxjs/operators';
import { RolePrivilegeService } from 'src/app/services/role.privilege.service';
import { ToastrUtil } from 'src/app/util/toastr.util';
import { WebConstants } from 'src/app/util/web.constants';
import { RolePrivilegeDialogComponent } from './role-privilege-dialog/role-privilege-dialog.component';

@Component({
  selector: 'app-role',
  templateUrl: './role.component.html',
  styleUrls: ['./role.component.scss']
})
export class RoleComponent implements OnInit {
  public columnHeader: string[] = [
    'roleName',
    'roleDescription',
    'status',
    'action'
  ];

  public roleList = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public dataSource = new MatTableDataSource();

  constructor(public rolePrivilegeService: RolePrivilegeService,
    public matDialog: MatDialog,
    public toaster: ToastrUtil) {
  }

  ngOnInit() {
    this.init();
  }

  init(): void {
    this.getAllRoles();
  }

  getAllRoles(): void {
    this.rolePrivilegeService.getAllRoles()
      .pipe(first())
      .subscribe(response => {
        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          if (response.data && response.data.length > WebConstants.INT_ZERO) {
            this.roleList = response.data;

            this.dataSource = new MatTableDataSource(this.roleList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.roleList = [];
          }
        }
      });
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getPrivilegesByRoleId(element: any): void {
    const dialog = this.matDialog.open(RolePrivilegeDialogComponent, {
      width: '1000px',
      data: element.id,
    });

    dialog.afterClosed().subscribe(result => {
      this.getAllRoles();
    });
  }

  getAllPrivileges(roleId: Number): any {
    return this.rolePrivilegeService.getPrivilegesByRoleId(roleId)
      .pipe(first())
      .subscribe(response => {
        if (response.code === WebConstants.STATUS.CODE_SUCCESS) {
          if (response.data && response.data.length > WebConstants.INT_ZERO) {
            this.roleList = response.data;

            this.dataSource = new MatTableDataSource(this.roleList);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
          } else {
            this.roleList = [];
          }
        }
      });
  }
}